import { ReactElement } from 'react';

import { Box, Stack } from '@mui/material';
import { styled } from '@mui/system';
import { Outlet } from 'react-router-dom';

import { APP_LAYOUT_HEIGHT } from '@/config';

import { AppHeader, AppSidebar } from '../app';

const SIDEBAR_EXPANDED_WIDTH = 280;

const Content = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  flexGrow: 1,
  flexBasis: `calc(100vh - ${APP_LAYOUT_HEIGHT.HEADER}px)`,
  backgroundColor: '#F9F9FA',
  overflow: 'auto',
});

export const MainLayout = (): ReactElement => {
  return (
    <Stack height="100vh" direction="row">
      <AppSidebar />
      <Stack
        width={`calc(100% - ${SIDEBAR_EXPANDED_WIDTH}px)`}
        flexGrow={1}
        flexShrink={1}
      >
        <AppHeader />
        <Content>
          <Outlet />
        </Content>
      </Stack>
    </Stack>
  );
};
